import { useLingui } from "@lingui/react/macro";
import { FilterBanner } from "@/components/FilterBanner/FilterBanner";
import {
  usePatientNameFilterActions,
  usePatientsFilterBannerItem,
} from "./PatientsContext";

export const PatientsFilterBannerSection = () => {
  const { t } = useLingui();
  const patientNameFilterItem = usePatientsFilterBannerItem(t`Patient`);
  const { clearFilterValue } = usePatientNameFilterActions();

  return (
    <FilterBanner
      filters={[patientNameFilterItem]}
      onClearAllFilters={clearFilterValue}
    />
  );
};
